import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "select-none text-red-400 text-sm",
  style: {"max-width":"300px"}
}
const _hoisted_2 = {
  key: 1,
  class: "select-none text-gray-400 text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large DeliveryModal",
    title: "Верификация доставки",
    loading: _ctx.state.is_loading || _ctx.verification_state.is_loading,
    "confirm-button-text": _ctx.modalConfirmText,
    onConfirm: _ctx.onConfirm,
    onCancel: _ctx.emitCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["flex items-center", {
                'justify-end': !_ctx.isTimerActive,
                'justify-between': _ctx.isTimerActive || _ctx.sms_state.is_failed,
            }])
      }, [
        (_ctx.sms_state.is_failed)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, " При отправке СМС кода произошла ошибка, попробуйте ещё раз "))
          : _createCommentVNode("", true),
        (_ctx.isTimerActive)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Повторная отправка через: " + _toDisplayString(_ctx.timer_state.left_time), 1))
          : _createCommentVNode("", true),
        (!_ctx.isHashReceived)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 2,
              loading: _ctx.sms_state.is_loading,
              class: "primary small",
              onClick: _ctx.sendSMS
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Отправить СМС код ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"]))
          : (_openBlock(), _createBlock(_component_the_button, {
              key: 3,
              disabled: _ctx.isTimerActive,
              loading: _ctx.sms_state.is_loading,
              class: "primary small",
              onClick: _ctx.sendSMS
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Отправить СМС код повторно ")
              ]),
              _: 1
            }, 8, ["disabled", "loading", "onClick"]))
      ], 2),
      _createVNode(_component_the_input, {
        class: "mt-2",
        placeholder: "Введите СМС код",
        value: _ctx.state.sms_code,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.sms_code) = $event)),
        "is-invalid": _ctx.state_form$.sms_code.$error,
        "validation-errors": _ctx.state_form$.sms_code.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["loading", "confirm-button-text", "onConfirm", "onCancel"]))
}